import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface FilterState {
  search?: string;
  year?: string;
  status?: string;
  searchBy?: string;
  educationLevel?: string;
  sortBy?: string;
  sortOrder?: string;
  timeSlot?: string;
}

const initialState: FilterState = {
  search: "",
  year: "",
  status: "",
  searchBy: "",
  educationLevel: "",
  sortBy: "",
  sortOrder: "",
  timeSlot: "",
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<FilterState>) => {
      state.search = action.payload.search;
      state.year = action.payload.year;
      state.status = action.payload.status;
      state.searchBy = action.payload.searchBy;
      state.educationLevel = action.payload.educationLevel;
      state.sortBy = action.payload.sortBy;
      state.sortOrder = action.payload.sortOrder;
      state.timeSlot = action.payload.timeSlot;
    },
  },
});

export const { setFilters } = filterSlice.actions;

export default filterSlice.reducer;
